<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt"><span class="hlink" href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt1"><a class="hlink" href="#/c01_intro">A Bad Day at Duke's East</a></p>
<p class="crt"><span class="hlink" href="#/c02_intro" title="Link target outside of Sample">The Dun Mare's Grandchild</span></p>
<p class="crt"><span class="hlink" href="#/c03_intro" title="Link target outside of Sample">Dream's Quarry</span></p>
<p class="crt"><span class="hlink" href="#/c04_intro" title="Link target outside of Sample">Gifts</span></p>
<p class="crt"><span class="hlink" href="#/c05_intro" title="Link target outside of Sample">First Blood</span></p>
<p class="crt"><span class="hlink" href="#/c06_intro" title="Link target outside of Sample">Mercenary's Honor</span></p>
<p class="crt"><span class="hlink" href="#/c07_intro" title="Link target outside of Sample">Consequences</span></p>
<p class="center"><span class="hlink" href="#/alsoby" title="Link target outside of Sample">Also by Elizabeth Moon</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?64ef6f46